<template>
    <div class="pushPage">
        <div class="container-puf">
            <div class="name">涉嫌拔管行为</div>
            <div class="list">
                <div class="item" v-for="(item,index) in dataList" :key="index">
                    <div class="title">{{item.startTime}} - {{item.endTime}} 涉嫌拔管行为</div>
                    <div class="content">{{item.content}}</div>
                    <div class="time">{{item.createTime}}</div>
                    <div class="other">
                        <div class="fileDown" @click="uploadFile(item.filePath)">附件下载</div>
                        <div class="detail" @click="getDetail(item.id)">查看详情</div>
                    </div>
                </div>
            </div>

            <div class="pagination" v-if="total>=form.pageSize">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page.sync="form.page"
                        :page-size="form.pageSize"
                        layout="total, prev, pager, next"
                        :total="total">
                </el-pagination>
            </div>

        </div>
        <el-dialog
                title="详情"
                :visible.sync="detailVisible"
                width="1200px"
        >
            <!--            <div class="form">-->
            <!--                <div class="item">-->
            <!--                    <span class="name">企业名称</span>-->
            <!--                    <span class="value">-->
            <!--                     <el-input size="mini" v-model="detailForm.psName"></el-input>-->
            <!--                </span>-->
            <!--                </div>-->
            <!--                <div class="item">-->
            <!--                    <span class="name">行业</span>-->
            <!--                    <span class="value">-->
            <!--                      <el-select v-model="detailForm.year" size="mini" style="width:178px" placeholder="请选择">-->
            <!--                        <el-option label="2020" value="2020"></el-option>-->
            <!--                        <el-option label="2021" value="2021"></el-option>-->
            <!--                        <el-option label="2022" value="2022"></el-option>-->
            <!--                        <el-option label="2023" value="2023"></el-option>-->
            <!--                      </el-select>-->
            <!--                </span>-->
            <!--                </div>-->

            <!--                <div class="item">-->
            <!--                    <span class="name">污染物</span>-->
            <!--                    <span class="value">-->
            <!--                      <el-select v-model="detailForm.status" multiple collapse-tags size="mini"  style="width:178px" placeholder="请选择">-->
            <!--                        <el-option label="未执行" :value="-1"></el-option>-->
            <!--                        <el-option label="执行中" :value="0"></el-option>-->
            <!--                        <el-option label="执行成功" :value="1"></el-option>-->
            <!--                        <el-option label="执行失败" :value="2"></el-option>-->
            <!--                      </el-select>-->
            <!--                </span>-->
            <!--                </div>-->

            <!--                <div class="item btnGroup">-->
            <!--                    <div class="btn"><el-button type="primary" icon="el-icon-search" size="mini">查询</el-button></div>-->
            <!--                </div>-->

            <!--            </div>-->

            <el-table
                    :data="detailList"
                    :header-cell-style="{background:'#FCFCFC',color:'#000000'}"
                    size="mini"
                    style="width: 100%">
                                <el-table-column
                                        prop="provice"
                                        align='center'
                                        show-overflow-tooltip
                                        label="省份">
                                </el-table-column>
<!--                <el-table-column-->
<!--                        prop="city"-->
<!--                        align='center'-->
<!--                        show-overflow-tooltip-->
<!--                        label="城市名称">-->
<!--                </el-table-column>-->
                <el-table-column
                        prop="name"
                        align='center'
                        show-overflow-tooltip
                        label="污染物名称">
                </el-table-column>
                <el-table-column
                        prop="psName"
                        align='center'
                        show-overflow-tooltip
                        width="120"
                        label="企业名称">
                </el-table-column>
                <el-table-column
                        prop="mpName"
                        align='center'
                        show-overflow-tooltip
                        width="140"
                        label="排放口名称">
                </el-table-column>
                <el-table-column
                        prop="industryName"
                        align='center'
                        show-overflow-tooltip
                        label="行业">
                </el-table-column>
                <el-table-column
                        prop="dataTime"
                        align='center'
                        show-overflow-tooltip
                        label="日期">
                </el-table-column>
                <el-table-column
                        prop="consistence"
                        align='center'
                        width="120"
                        show-overflow-tooltip
                        label="实测浓度(ug/m3)">
                </el-table-column>
<!--                <el-table-column-->
<!--                        align='center'-->
<!--                        label="操作">-->
<!--                    <template slot-scope="scope">-->
<!--                        <el-button type="text" @click="timeInfo(scope.row)">变化趋势</el-button>-->
<!--                    </template>-->
<!--                </el-table-column>-->
            </el-table>
            <div class="pagination">
                <el-pagination
                        @size-change="handleDSizeChange"
                        @current-change="handleDCurrentChange"
                        :current-page.sync="detailForm.page"
                        :page-size="detailForm.pageSize"
                        layout="total, prev, pager, next"
                        :total="Dtotal">
                </el-pagination>
            </div>


            <el-dialog
                    width="900px"
                    title="变化趋势"
                    :visible.sync="innerVisible"
                    append-to-body>
                <div class="lowChart">
                    <echarts :charts-option="charts"></echarts>
                </div>

            </el-dialog>

        </el-dialog>
    </div>
</template>

<script>
    import moment from 'moment'
    import {
        sourcePushactOfExtubationInfo,
        sourcePushexceptionIdentificationInfo,
        sourcePushonlineHourData,
        sourcePushpage
    } from "../../../api/push";
    import Echarts from "../../../components/echart/echarts";
    import {henanClueDownload} from "@/api/noCode";
    import exportFile from "@/util/exportFile";

    export default {
        name: "variation",
        components: {Echarts},
        data(){
            return {
                form: {
                    page:1,
                    pageSize:10,
                    type:5,
                },
                dataList:[],
                total:0,
                detailVisible:false,
                detailForm: {
                    page:1,
                    pageSize:10,
                    pushId:""
                },
                detailList:[],
                Dtotal:0,
                innerVisible:false,
                charts:{
                    title: {
                        text: ''
                    },
                    tooltip: {
                        trigger: 'axis'
                    },
                    legend: {
                        data: ['折算浓度(ug/m3)',
                            '烟气温度(℃)',
                            '烟气量(m3/h)',
                            '含氣量(%)',
                            'NOx变化率(%)',
                        ]
                    },
                    grid: {
                        left: '3%',
                        right: '160px',
                        bottom: '3%',
                        containLabel: true
                    },
                    toolbox: {
                        feature: {
                            saveAsImage: {}
                        }
                    },
                    xAxis: {
                        type: 'category',
                        boundaryGap: false,
                        data: []
                    },
                    yAxis: [
                        {
                            type: 'value',
                            name: '折算浓度(ug/m3)',
                            axisLine: {
                                show: true,
                            },
                        },
                        {
                            type: 'value',
                            name: '烟气温度(℃)',
                            position: 'right',
                            axisLine: {
                                show: true,
                            },
                        },
                        {
                            type: 'value',
                            name: '烟气量(m3/h)',
                            position: 'right',
                            offset: 80,
                            axisLine: {
                                show: true,
                            },
                        },
                        {
                            type: 'value',
                            name: '含氣量(%)',
                            position: 'right',
                            offset: 160,
                            axisLine: {
                                show: true,
                            },
                        },
                        // {
                        //     type: 'value',
                        //     name: 'NOx变化率(%)',
                        //     position: 'right',
                        //     offset: 240,
                        //     axisLine: {
                        //         show: true,
                        //     },
                        // }
                    ],
                    series: []
                },
            }
        },
        mounted(){
            this.getData()
        },
        methods:{
            getData(){
                sourcePushpage(this.form).then(res=>{
                    // console.log(res)
                    this.dataList = res.data.list
                    this.total = res.data.totalCount
                })
            },

            handleSizeChange(val) {
                this.form.pageSize = val
                this.getData()
            },
            handleCurrentChange(val) {
                this.form.page = val
                this.getData()
            },

            getDetail(id){
                this.detailForm.pushId = id
                this.detailVisible = true
                this.getInfo()
            },

            getInfo(){
                let data = this.detailForm
                sourcePushactOfExtubationInfo(data).then(res=>{
                    this.detailList = res.data.list
                    this.Dtotal = res.data.totalCount
                })
            },

            handleDSizeChange(val) {
                this.detailForm.pageSize = val
                this.getInfo()
            },
            handleDCurrentChange(val) {
                this.detailForm.page = val
                this.getInfo()
            },


            timeInfo(item){
                let data = {
                    psName:item.psName,
                    mpName:item.mpName,
                    name:item.name,
                    startTime:moment(new Date(item.dataTime +' 00:00:00')).add(-2,'day').format('yyyy-MM-DD HH:mm:ss'),
                    endTime:moment(new Date(item.dataTime +' 00:00:00')).add(1,'day').format('yyyy-MM-DD HH:mm:ss'),
                }


                this.innerVisible = true

                sourcePushonlineHourData(data).then(res=>{
                    let list = res.data

                    let timeList=[]

                    let seriesData = [
                        {
                            name: '折算浓度(ug/m3)',
                            type: 'line',
                            stack: 'Total',
                            data: [],
                            yAxisIndex: 0
                        },
                        {
                            name: '烟气温度(℃)',
                            type: 'line',
                            stack: 'Total',
                            data: [],
                            yAxisIndex: 1
                        },
                        {
                            name: '烟气量(m3/h)',
                            type: 'line',
                            stack: 'Total',
                            data: [],
                            yAxisIndex: 2,
                            offset:30,
                        },
                        {
                            name: '含氣量(%)',
                            type: 'line',
                            stack: 'Total',
                            data: [],
                            yAxisIndex: 3
                        },
                        // {
                        //     name: 'NOx变化率(%)',
                        //     type: 'line',
                        //     stack: 'Total',
                        //     data: [],
                        //     yAxisIndex: 4
                        // },
                    ]

                    list.forEach(item=>{
                        timeList.push(item.dataTime)
                        seriesData[0].data.push(item.avgZs)
                        seriesData[1].data.push(item.wd)
                        seriesData[2].data.push(item.b02)
                        seriesData[3].data.push(item.yhl)
                        // seriesData[4].data.push(item.avgZs)
                    })

                    this.charts.series = seriesData
                    this.charts.xAxis.data = timeList

                })

            },

          uploadFile(path){
            henanClueDownload({filePath:path}).then(res=>{
              exportFile.getExcel(res.data,  decodeURI(res.headers.name))
            })
          },
        }
    }
</script>

<style scoped lang="less">

    @import "../config";

</style>
